/**
 * Rct Page Loader
 */
import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

const RctPageLoader = () => (
    <div className="d-flex justify-content-center loader-overlay">
        <CircularProgress />
    </div>
);

export default RctPageLoader;
